var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import RefreshLabel from "@frameworks/web/components/generic/CountInput/RefreshLabel";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
var BuySellBtn = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "buy-sell-col" },
                React.createElement(Row, { className: "mtg-10 bg-white" },
                    props.buySellRefresh && (React.createElement(Col, { lg: 3, className: "col-2 px-0 pe-3 d-flex align-items-center justify-content-evenly" },
                        React.createElement(RefreshLabel, { title: props.refreshLabelTitle, icon: true, onCallBackFunction: function () {
                                props.setConvert && (props === null || props === void 0 ? void 0 : props.setConvert(true));
                                props.onCallBackFunction && (props === null || props === void 0 ? void 0 : props.onCallBackFunction());
                            }, mobRefresh: props === null || props === void 0 ? void 0 : props.mobRefresh, parentClassName: "toc-buy-sell  ".concat(props.refreshLabelClassName) }))),
                    React.createElement(Col, { lg: props.buySellRefresh ? 9 : 12, xs: props.buySellRefresh ? 9 : 12, className: "col-10 px-0" },
                        React.createElement(Row, { className: "bottombtnsection" },
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-2 ps-0" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: props.cancelText ? props.cancelText : "Cancel", className: "w-100 ".concat(props === null || props === void 0 ? void 0 : props.cancelButtonClassName), onClick: function () { return props.cancelAction(); } })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-2 pe-0" },
                                React.createElement(EdButton, __assign({}, props.rightButton))))))))));
};
export default BuySellBtn;
